import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Category() {
  const { slug } = useParams();
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState(null);

  useEffect(() => {
    api.get("/categories").then((r) => {
      const c = r.data.find((x) => x.slug === slug);
      setCategory(c);
    });
    api.get(`/products?category=${slug}`).then((r) => setProducts(r.data));
  }, [slug]);

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <div className="border-b border-slate-200 pb-6 mb-8">
        <Link to="/products" className="text-xs font-mono-tmf uppercase tracking-widest text-slate-500 hover:text-orange-600">← All Products</Link>
        <div className="text-[10px] font-mono-tmf uppercase tracking-widest text-orange-600 mt-3 mb-2">Category</div>
        <h1 className="font-display font-black text-4xl md:text-5xl uppercase tracking-tight">{category?.name || slug.replace(/-/g, " ")}</h1>
        {category?.description && <p className="mt-2 text-sm text-slate-600">{category.description}</p>}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {products.map((p) => <ProductCard key={p.product_id} product={p} />)}
      </div>
      {products.length === 0 && (
        <div className="text-center py-16 border border-slate-200">
          <div className="font-display font-bold text-xl">No products in this category yet.</div>
        </div>
      )}
    </div>
  );
}
